import { useUser } from "@features/user-account/queries"
import { Card, Kbd, Stack, Table, Text } from "@mantine/core"

export const YourAccountStep: React.FC = () => {

    const { data: user } = useUser()

    return (
        <Stack gap="xl" w={600}>
            <Text>
                Various systems and services at College require a username and password.
            </Text>
            <Stack gap="xs">
                <Text fw={700}>
                    Your username
                </Text>
                <Text>
                    Depending on what you're logging into, your username will be either:
                </Text>
                <Card p={0} withBorder mt="xs">
                    <Table variant="vertical" layout="fixed">
                        <Table.Tbody>
                            <Table.Tr>
                            <Table.Th w={200}>Your Student Number</Table.Th>
                            <Table.Td>{user?.userPrincipalName?.split("@")[0]}</Table.Td>
                            </Table.Tr>

                            <Table.Tr>
                            <Table.Th>Your College email address</Table.Th>
                            <Table.Td>{user?.userPrincipalName}</Table.Td>
                            </Table.Tr>
                        </Table.Tbody>
                    </Table>
                </Card> 
            </Stack>
            <Stack gap="xs">
                <Text fw={700}>
                    Your password
                </Text>
                <Text>
                    This is the password you just created. It will not change during your time at College, unless you forget it or it is compromised.
                </Text>
                <Text>
                    Please <Text span fw={600}>do not share your password</Text>. College staff will never ask for it. If you think someone knows your password, change it as soon as possible by visiting the IT Helpdesk or logging into a College computer and pressing <Kbd>Ctrl</Kbd> + <Kbd>Alt</Kbd> + <Kbd>Delete</Kbd>.
                </Text>
            </Stack>
        </Stack>
    )
}